import { render, staticRenderFns } from "./SquareGrid.vue?vue&type=template&id=d4765dd8&scoped=true&"
import script from "./SquareGrid.vue?vue&type=script&lang=js&"
export * from "./SquareGrid.vue?vue&type=script&lang=js&"
import style0 from "./SquareGrid.vue?vue&type=style&index=0&id=d4765dd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4765dd8",
  null
  
)

export default component.exports